import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {UserTrace} from "@commons/types";
import {GiustificazioneAutoRecord} from "@commons/mapping/GiustificazioneAutoRecord";

export type PeriodoControllo = "GIORNO" | "SETTIMANA" | "MESE";
export type OrdinaEventi = "NON_ORDINARE" | "CRESCENTE" | "DECRESCENTE";
export type TipoDecurtamento = "MIN_EFFETTIVI" | "MIN_ARROTONDATI";

export interface TolleranzaRecord extends URIAndTrace {
    idAziendaTabelle: number;

    idTolleranza: number;
    descrizione: string;
    entrata1Bonus: number;
    entrata2Bonus: number;
    entrata1GiuBonus: string;
    entrata2GiuBonus: string;
    entrata1Ritardo: number;
    entrata2Ritardo: number;
    scartoMaxQta: number;
    entrata1GiuRitardo: string;
    entrata2GiuRitardo: string;
    scartoMaxGiu: string;
    periodoControllo: PeriodoControllo;
    maxMinuti: number;
    maxEventi: number;
    perditaDiritto: boolean;
    ordinaEventi: OrdinaEventi;
    tipoDecurtamento: TipoDecurtamento;

    abilitaTolleranza: boolean;
    entrata1GiuBonusFP: string;
    entrata2GiuBonusFP: string;
    abilitaGiustificazioneRitarto: boolean;
    insertTrace: UserTrace;
}

export class TolleranzaRecord {
    static getRegolaBonus = (that: TolleranzaRecord, idRegola: number, minutiMancanti: number) => {
        return GiustificazioneAutoRecord.factory({
            codGiu: (idRegola === 1) ? that.entrata1GiuBonus : that.entrata2GiuBonus,
            descrizione: '*TOLLERANZA*',
            //controllo: 'COME_MANCANTE',
            controllo: 'NESSUN_CONTROLLO',
            ore: minutiMancanti / 60.0,
            azioneXGiuPresente: 'SOSTITUISCI',
            tipologiaGiornata: 'QUALSIASI',
            controlloSuPrevisto: 'QUALSIASI',
            controlloSuOreLavorate: 'QUALSIASI',
            controlloSuOreMancanti: 'QUALSIASI',
            controlloAltriGiu: 'NESSUN_CONTROLLO',
            controlloAccumulo: 'NESSUN_CONTROLLO',
            valMin: 0.01,
            valMax: (idRegola === 1) ? that.entrata1Bonus : that.entrata2Bonus
        });
    };

}